if (!customElements.get('video-custom')) {
  customElements.define(
    'video-custom',
    class CustomVideo extends HTMLElement {
      constructor() {
        super();
        this.video = this.querySelector('video');
        this.playButton = this.querySelector('.play-button');
        this.pauseButton = this.querySelector('.pause-button');
        this.muteButton = this.querySelector('.mute-button');
        this.unmuteButton = this.querySelector('.unmute-button');
      }

      connectedCallback() {
        this.updateIcons();

        // Play/pause functionality
        this.playButton.addEventListener('click', () => this.togglePlayPause());
        this.pauseButton.addEventListener('click', () => this.togglePlayPause());

        // Mute/unmute functionality
        if (this.muteButton) this.muteButton.addEventListener('click', () => this.toggleMuteUnmute());
        if (this.unmuteButton) this.unmuteButton.addEventListener('click', () => this.toggleMuteUnmute());

        // Update icons when video state changes
        this.video.addEventListener('play', () => this.updateIcons());
        this.video.addEventListener('pause', () => this.updateIcons());
      }

      togglePlayPause() {
        this.video.paused ? this.video.play() : this.video.pause();
        this.updateIcons();
      }

      toggleMuteUnmute() {
        this.video.muted = !this.video.muted;
        this.updateIcons();
      }

      updateIcons() {
        // Toggle play/pause icons
        const isPlaying = !this.video.paused;
        this.playButton.style.display = isPlaying ? 'none' : 'block';
        this.pauseButton.style.display = isPlaying ? 'block' : 'none';

        // Toggle mute/unmute icons
        const isMuted = this.video.muted;
        if (this.muteButton) this.muteButton.style.display = isMuted ? 'block' : 'none';
        if (this.unmuteButton) this.unmuteButton.style.display = isMuted ? 'none' : 'block';
      }
    },
  );
}
